// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imgtext-section {
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 80px 48px;
  max-width: 1400px;
  margin: 0 auto;
}

.imgtext-section--reverse {
  flex-direction: row-reverse;
}

.imgtext-text {
  flex: 1;
  min-width: 0;
}

.imgtext-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 24px;
}

.imgtext-body {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 32px;
}

.imgtext-bullets {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 32px;
}

.imgtext-bullet {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.imgtext-bullet-icon {
  color: #4CAF50;
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.imgtext-bullet-text {
  font-size: 15px;
  line-height: 1.5;
  color: #555;
  margin: 0;
}

.imgtext-image-wrapper {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imgtext-image {
  width: 100%;
  height: auto;
  max-width: 500px;
  border-radius: 12px;
  object-fit: cover;
}

.imgtext-button {
  background-color: #000;
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.imgtext-button:hover {
  background-color: #e06fb5;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(244, 133, 199, 0.3);
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
  .imgtext-section {
    gap: 40px;
    padding: 60px 32px;
  }

  .imgtext-title {
    font-size: 28px;
  }
}

/* Mobile breakpoint - stack vertically */
@media (max-width: 768px) {
  .imgtext-section {
    flex-direction: column !important;
    gap: 40px;
    padding: 60px 24px;
  }

  .imgtext-section--reverse {
    flex-direction: column !important;
  }

  .imgtext-text {
    width: 100%;
  }

  .imgtext-image-wrapper {
    width: 100%;
  }

  .imgtext-image {
    max-width: 100%;
  }

  .imgtext-title {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .imgtext-body {
    font-size: 15px;
    margin-bottom: 24px;
  }

  .imgtext-bullet-text {
    font-size: 14px;
  }
}

/* Small mobile breakpoint */
@media (max-width: 480px) {
  .imgtext-section {
    padding: 40px 20px;
    gap: 32px;
  }

  .imgtext-title {
    font-size: 22px;
  }

  .imgtext-bullets {
    gap: 16px;
  }

  .imgtext-button {
    width: 100%;
    padding: 12px 24px;
  }
}`, "",{"version":3,"sources":["webpack://./frontends/ecstore-frontend/src/Components/ImgTextBlocks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,iCAAiC;IACjC,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".imgtext-section {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n  padding: 80px 48px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.imgtext-section--reverse {\n  flex-direction: row-reverse;\n}\n\n.imgtext-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.imgtext-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 24px;\n}\n\n.imgtext-body {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #666;\n  margin-bottom: 32px;\n}\n\n.imgtext-bullets {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.imgtext-bullet {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.imgtext-bullet-icon {\n  color: #4CAF50;\n  font-size: 20px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.imgtext-bullet-text {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #555;\n  margin: 0;\n}\n\n.imgtext-image-wrapper {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.imgtext-image {\n  width: 100%;\n  height: auto;\n  max-width: 500px;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.imgtext-button {\n  background-color: #000;\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  font-size: 16px;\n  font-weight: 400;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.imgtext-button:hover {\n  background-color: #e06fb5;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(244, 133, 199, 0.3);\n}\n\n/* Tablet breakpoint */\n@media (max-width: 1024px) {\n  .imgtext-section {\n    gap: 40px;\n    padding: 60px 32px;\n  }\n\n  .imgtext-title {\n    font-size: 28px;\n  }\n}\n\n/* Mobile breakpoint - stack vertically */\n@media (max-width: 768px) {\n  .imgtext-section {\n    flex-direction: column !important;\n    gap: 40px;\n    padding: 60px 24px;\n  }\n\n  .imgtext-section--reverse {\n    flex-direction: column !important;\n  }\n\n  .imgtext-text {\n    width: 100%;\n  }\n\n  .imgtext-image-wrapper {\n    width: 100%;\n  }\n\n  .imgtext-image {\n    max-width: 100%;\n  }\n\n  .imgtext-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n\n  .imgtext-body {\n    font-size: 15px;\n    margin-bottom: 24px;\n  }\n\n  .imgtext-bullet-text {\n    font-size: 14px;\n  }\n}\n\n/* Small mobile breakpoint */\n@media (max-width: 480px) {\n  .imgtext-section {\n    padding: 40px 20px;\n    gap: 32px;\n  }\n\n  .imgtext-title {\n    font-size: 22px;\n  }\n\n  .imgtext-bullets {\n    gap: 16px;\n  }\n\n  .imgtext-button {\n    width: 100%;\n    padding: 12px 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
